export const GET_QUIZ_RESULTS = `query getQuizResults ($childId: Int!) {
            quizResults(child_id: $childId) {
                recommendedApproaches {
                title
                skill
                _id
                recommendedApproachExercises {
                    _key
                    age
                    benefit
                    result
                    skill
                    title
                    exercises
                    benefits
                }
                }
                quizResultsSection {
                title
                childName
                subTitle
                items {
                    age
                    category
                    mainImageUrl
                    result
                    title
                }
                }
                keyFocusAreas {
                _id
                badResultColor
                goodResultColor
                normalResultColor
                title
                subTitle
                skill
                keyFocusAreaItems {
                    _key
                    age
                    category
                    content
                    result
                    recommendations
                }
                }
            }
}`;
